import moment from 'moment';
import { params } from "../../modules/events/movePages";
import { eventPayload, form, primaryColor } from "../../utils/variables";
import { rescheduleAppointment, primeRescheduleSignatureParams } from "../../services/selectTimeService";
import { toastSuccess, toastError } from "./common/toast";
import { getProviderFullName } from "../../modules/actions/providerActions";

let newStartTime = null;
let newEndTime = null;

export async function loadAppointmentRescheduleReason(startTime, endTime) {
    if (!eventPayload) return;

    newStartTime = startTime;
    newEndTime = endTime;

    primeRescheduleSignatureParams();
    initializeStyles();
    setBusinessLogo();
    setClientPortalSignInLink();
    renderAppointmentInfo();
    showRescheduleReasonForm();
}

function initializeStyles() {
    const informationCard = document.querySelector('.appointment-reschedule-reason__container .appointment-reschedule-reason__datetime-section .card');
    if (informationCard) informationCard.style.backgroundColor = 'transparent';
}

function getClientPortalUrl() {
    const fromBackend = form?.data?.client_portal_url;
    if (fromBackend) return fromBackend;
    const base = form?.data?.dashboard_base_url || form?.project?.client_portal_base_url || form?.project?.dashboard_base_url || window.location.origin;
    const baseClean = String(base).replace(/\/$/, '');
    const projectUuid = form?.project?.uuid;
    return projectUuid ? `${baseClean}/client/portal/${projectUuid}` : `${baseClean}/client/portal`;
}

function setClientPortalSignInLink() {
    const link = document.getElementById('header-sign-in-client-portal-reschedule');
    if (!link) return;
    link.setAttribute('href', getClientPortalUrl());
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
}

function setBusinessLogo() {
    if (form?.project?.business_photo) {
        document.querySelector('.appointment-reschedule-reason__container .appointment__logo')?.setAttribute('src', form.project.business_photo);
    }
}

function renderAppointmentInfo() {
    const currentStartTime = parseInt(eventPayload.start_time);
    const staffName = getStaffName();

    const currentDetailsElement = document.querySelector('.appointment-reschedule-reason__container .current-details');
    if (currentDetailsElement) {
        const currentDate = moment(currentStartTime * 1000).format('dddd, MMMM DD, YYYY');
        const currentTime = moment(currentStartTime * 1000).format('h:mm A');
        currentDetailsElement.innerHTML = `
            ${currentDate} at ${currentTime}<br>
            with ${staffName}
        `;
    }

    const newDetailsElement = document.querySelector('.appointment-reschedule-reason__container .new-details');
    if (newDetailsElement && newStartTime) {
        const newDate = moment(newStartTime * 1000).format('dddd, MMMM DD, YYYY');
        const newTime = moment(newStartTime * 1000).format('h:mm A');
        newDetailsElement.innerHTML = `
            ${newDate} at ${newTime}<br>
            with ${staffName}
        `;
    }
}

function getStaffName() {
    if (eventPayload.participants && eventPayload.participants.length > 0 && params('event_id')) {
        const participant = eventPayload.participants.find(i => i.participable_type === 'App\\Models\\Staff');
        return participant ? `${participant.participable.first_name} ${participant.participable.last_name}` : '';
    }
    return getProviderFullName(eventPayload.staff);
}

function showRescheduleReasonForm() {
    const actionDiv = document.querySelector('.appointment-reschedule-reason__container .action');
    if (!actionDiv) return;

    const formHtml = `
        <div class="reschedule-reason-form">
            <div class="reschedule-reason-form__header">
                <h3>Please tell us why <span class="required">*</span></h3>
            </div>
            <div class="reschedule-reason-form__reasons">
                <button type="button" class="reason-btn" data-reason="Schedule conflict">Schedule conflict</button>
                <button type="button" class="reason-btn" data-reason="Emergency">Emergency</button>
                <button type="button" class="reason-btn" data-reason="Personal reasons">Personal reasons</button>
            </div>
            <div class="reschedule-reason-form__textarea">
                <textarea 
                    id="reschedule-reason-textarea" 
                    placeholder="Tell us your reason for rescheduling..."
                    maxlength="500"
                    rows="4"
                    required
                ></textarea>
            </div>
            <div class="reschedule-reason-form__actions">
                <button type="button" id="confirm-reschedule-btn" class="confirm-reschedule-btn" disabled>
                    Confirm Reschedule
                </button>
            </div>
        </div>
    `;

    actionDiv.innerHTML = formHtml;

    if (typeof feather !== 'undefined') {
        feather.replace();
    }

    setupRescheduleReasonFormListeners();
}

function setupRescheduleReasonFormListeners() {
    const textarea = document.getElementById('reschedule-reason-textarea');
    const confirmBtn = document.getElementById('confirm-reschedule-btn');
    const reasonBtns = document.querySelectorAll('.reason-btn');

    if (textarea) {
        textarea.addEventListener('input', function () {
            const length = this.value.length;
            if (confirmBtn) {
                confirmBtn.disabled = length < 10;
            }
        });
    }

    reasonBtns.forEach(btn => {
        btn.addEventListener('click', function () {
            reasonBtns.forEach(b => b.classList.remove('active'));

            this.classList.add('active');

            if (textarea) {
                const reason = this.getAttribute('data-reason');
                textarea.value = reason;
                textarea.dispatchEvent(new Event('input'));
            }
        });
    });

    if (confirmBtn) {
        confirmBtn.addEventListener('click', handleConfirmReschedule);
    }
}

async function handleConfirmReschedule() {
    const textarea = document.getElementById('reschedule-reason-textarea');
    const confirmBtn = document.getElementById('confirm-reschedule-btn');

    if (!textarea || !textarea.value.trim()) {
        toastError('Please provide a reason for rescheduling');
        return;
    }

    if (textarea.value.trim().length < 10) {
        toastError('Please provide at least 10 characters for the reschedule reason');
        return;
    }

    try {
        if (confirmBtn) {
            confirmBtn.disabled = true;
            confirmBtn.innerHTML = 'Processing...';
        }

        const eventId = params('event_id');
        if (!eventId) {
            throw new Error('Event ID not found');
        }

        const response = await rescheduleAppointment(eventId, {
            start_time: newStartTime,
            end_time: newEndTime,
            reason: textarea.value.trim()
        });

        if (response && response.status === 200) {
            toastSuccess('Appointment rescheduled successfully');
            setTimeout(() => {
                const cleanUrl = `${response.data.navigation.frontend_url}?form_id=${response.data.navigation.url_params.form_id}&event_id=${response.data.navigation.url_params.event_id}`;
                try {
                    if (new URL(cleanUrl).origin === window.location.origin) {
                        window.history.replaceState({}, '', cleanUrl);
                    }
                } catch (_) {
                    // replaceState only allowed for same-origin URL; skip if frontend_url is different origin (e.g. widget vs assistant iframe)
                }
                window.location.replace(cleanUrl);
                if (window.parent !== window.self) {
                    window.parent.location.replace(cleanUrl);
                }
            }, 1500);
        } else {
            throw new Error('Failed to reschedule appointment');
        }
    } catch (error) {
        toastError('Failed to reschedule appointment. Please try again.');

        if (confirmBtn) {
            confirmBtn.disabled = false;
            confirmBtn.innerHTML = 'Confirm Reschedule';
        }
    }
}
